import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import classNames from 'classnames';
import styles from './button.module.scss';

const buttonClasses = props => {
  const {className, size, inverted, isOutlined} = props;
  return classNames(
    'button',
    'is-primary',
    'is-uppercase',
    `is-${size}`,
    styles.Button,
    className,
    {
      'is-inverted': inverted,
      'is-outlined': isOutlined,
    }
  );
};

const Button = props => {
  const {href, children, onClick} = props;
  let clickHandler;

  if (onClick) {
    clickHandler = e => {
      e.preventDefault();
      onClick();
    };
  }

  const anchorProps = {
    className: buttonClasses(props),
    href,
  };

  if (/http/.test(href)) {
    return <a {...anchorProps}>{children}</a>;
  }

  anchorProps.to = href;

  if (clickHandler) {
    anchorProps.onClick = clickHandler;
  }

  return <Link {...anchorProps}>{children}</Link>;
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  href: PropTypes.string,
  inverted: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  isOutlined: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  onClick: PropTypes.func,
  size: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
};

Button.defaultProps = {
  className: '',
  href: '#',
  inverted: false,
  size: 'small',
  isOutlined: true,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js